import BrButton from '@govbr/react-components/lib/BrButton';
import { Checkbox, Grid, Dialog, DialogContent, DialogContentText } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import imgAlerta from '../../assets/img/icone-alerta.png';
import imgErro from '../../assets/img/icone-erro.png';
import imgSucesso from '../../assets/img/icone-sucesso.png';
import auth from '../../auth/Auth';
import { authLimparDadosFamilia, authLogout, selectGovBr } from '../../auth/authSlice';
import AjudaRapida from '../../components/AjudaRapida/AjudaRapida';
import Card from '../../components/Card/Card';
import LoadingGlobal from '../../components/LoadingGlobal/LoadingGlobal';
import MainContainer from '../../components/MainContainer/MainContainer';
import Message from '../../components/Message/Message';
import { selectLogado } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import {
  getPermiteRemoverFamiliaCadUnico,
  getPermiteRemoverPreFamiliaCadUnico,
  selectPerfilCompleto,
  selectPermiteRemoverFamiliaCadUnico,
  selectPermiteRemoverPreFamiliaCadUnico,
  selectSituacaoCadastroFamilia
} from '../Perfil/perfilSlice';
import * as codigoMensagens from './codigosMensagens';
import ComposicaoFamiliar from './ComposicaoFamiliar/ComposicaoFamiliar';
import {
  excluirFamilia,
  excluirPreFamilia,
  limpar,
  limparResponseError,
  obterFamilia,
  obterPreFamilia,
  selectCodigoErro,
  selectExclusaoIniciada,
  selectFamilia,
  selectMensagemErro,
  selectResponseError
} from './exclusaoCadastralSlice';
import InicioExclusaoCadastral from './InicioExclusaoCadastral/InicioExclusaoCadastral';
import styles from './PainelExclusaoCadastral.module.css';
import { trackServiceSelect } from '../../common/tracker';
import { obterNomeDoPerfil } from '../../common/perfilUtils';

const PainelExclusaoCadastral: React.FC<any> = () => {
  const dispatch = useAppDispatch();

  const history = useHistory();

  const familia = useAppSelector(selectFamilia);

  const responseError = useAppSelector(selectResponseError);

  const [loading, setLoading] = useState(true);
  const exclusaoIniciada = useAppSelector(selectExclusaoIniciada);
  const codigoErro = useAppSelector(selectCodigoErro);
  const [exibirMensagemErro, setExibirMensagemErro] = useState(false);

  const mensagemErro = useAppSelector(selectMensagemErro);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);

  const perfil = useAppSelector(selectPerfilCompleto);
  const govBrLogado = useAppSelector(selectGovBr).logado;
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);

  const permiteRemoverFamiliaCadUnico = useAppSelector(selectPermiteRemoverFamiliaCadUnico);
  const permiteRemoverPreFamiliaCadUnico = useAppSelector(selectPermiteRemoverPreFamiliaCadUnico);
  const [familiaExcluida, setFamiliaExcluida] = useState(false);

  const [exibeTextoExplicativo, setExibeTextoExplicativo] = useState(false);

  useEffect(() => {
    if (auth.isAuthenticated() && perfil && perfil.numeroFamiliar && !permiteRemoverFamiliaCadUnico) {
      dispatch(
        getPermiteRemoverFamiliaCadUnico({
          cpf: auth.getUser(),
          numeroFamiliar: perfil.numeroFamiliar,
        })
      );
    }
  }, [dispatch, perfil]);

  useEffect(() => {
    if (auth.isAuthenticated() && situacaoCadastroFamilia?.idPreFamilia && !permiteRemoverPreFamiliaCadUnico) {
      if (situacaoCadastroFamilia.idPreFamilia) {
        dispatch(
          getPermiteRemoverPreFamiliaCadUnico({
            cpf: auth.getUser(),
            idPreFamilia: situacaoCadastroFamilia.idPreFamilia,
          })
        );
      }
    }
  }, [dispatch, situacaoCadastroFamilia]);

  useEffect(() => {
    if (
      ((perfil && perfil.numeroFamiliar && !permiteRemoverFamiliaCadUnico) ||
        (situacaoCadastroFamilia?.idPreFamilia && !permiteRemoverPreFamiliaCadUnico)) &&
      !familiaExcluida
    ) {
      history.replace('/home');
    }
  }, [permiteRemoverFamiliaCadUnico, familiaExcluida, history]);

  useEffect(() => {
    if (perfil && perfil.numeroFamiliar && !familia) {
      dispatch(obterFamilia({ cpf: auth.getUser(), numeroFamiliar: perfil.numeroFamiliar }));
    }
    if (situacaoCadastroFamilia?.idPreFamilia && !familia) {
      dispatch(
        obterPreFamilia({ cpf: auth.getUser(), idPreFamilia: situacaoCadastroFamilia.idPreFamilia })
      );
    }

    setLoading(false);
  }, [dispatch, perfil, situacaoCadastroFamilia, familia]);

  useEffect(() => {
    setExibirMensagemErro(codigoErro != null && codigoErro != '' ? codigoMensagens.codigosErro.includes(codigoErro) : false);
  }, [codigoErro]);

  useEffect(() => {
    return () => {
      dispatch(limparResponseError());
    };
  }, []);

  const [isCheckedDeclaracao, setIsCheckedDeclaracao] = useState(false);

  const handleOnChangeDeclaracao = () => {
    setIsCheckedDeclaracao(!isCheckedDeclaracao);
  };

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const confirmaExclusaoCadastroUnico = async () => {
    dispatch(limparResponseError());

    if (perfil && perfil.numeroFamiliar) {
      // Excluir se a família estiver cadastrada no cadastro único.
      await dispatch(
        excluirFamilia({ cpf: auth.getUser(), numeroFamiliar: perfil.numeroFamiliar })
      );
      trackServiceSelect('POR-CONFIRMAÇÃO', "EXCLUSÃO CADASTRAL FAMÍLIA");
    } else if (situacaoCadastroFamilia?.idPreFamilia) {
      // Excluir se a família estiver no pré-cadastro.
      await dispatch(
        excluirPreFamilia({
          cpf: auth.getUser(),
          idPreFamilia: situacaoCadastroFamilia.idPreFamilia,
        })
      );
      trackServiceSelect('POR-CONFIRMAÇÃO', "EXCLUSÃO CADASTRAL PRÉ-FAMÍLIA");
    }

    setFamiliaExcluida(true);
    // await dispatch(authLimparDadosFamilia({ history }));
  };

  const renderMessageSucesso = () => {
    return codigoErro && codigoMensagens.codigosSucesso.includes(codigoErro);
  };

  const renderMessageAlerta = () => {
    return codigoErro && codigoMensagens.codigosAlerta.includes(codigoErro);
  };

  const renderMessageErro = () => {
    return codigoErro && codigoMensagens.codigosErro.includes(codigoErro);
  };

  const goToHome = () => {
    dispatch(limpar());
    history.push('/home');
  };

  const exibicaoMensagens = () => {
    return (
      <div className={styles.container}>
        {renderMessageErro() && (
          <Card className={styles.card}>
            <div className={styles.containerMensagem}>
              <img className={styles.imgMessage} src={imgErro} alt="Imagem" />
              <Message
                type={'error'}
                text={
                  <>
                    <div>
                      <span>{mensagemErro}</span>
                    </div>
                  </>
                }
              />

              <p />
              <p />
              <div className={styles.botaoContainer}>
                <BrButton onClick={() => goToHome()} className={styles.botao}>
                  OK
                </BrButton>
              </div>
            </div>
          </Card>
        )}

        {renderMessageAlerta() && (
          <Card className={styles.card}>
            <div className={styles.containerMensagem}>
              <img className={styles.imgMessage} src={imgAlerta} alt="Imagem" />

              <Message
                type={'warning'}
                text={
                  <>
                    <div>
                      <span>{mensagemErro}</span>
                    </div>
                  </>
                }
              />
              <p />
              <p />
              <div className={styles.botaoContainer}>
                <BrButton onClick={() => goToHome()} className={styles.botao}>
                  OK
                </BrButton>
              </div>
            </div>
          </Card>
        )}

        {renderMessageSucesso() && (
          <Card className={styles.card}>
            <div className={styles.containerMensagem}>
              <img className={styles.imgMessage} src={imgSucesso} alt="Imagem" />

              <Message
                type={'success'}
                text={
                  <>
                    <div>
                      <span>{mensagemErro}</span>
                    </div>
                  </>
                }
              />
              <p />
              <p />
              <div className={styles.botaoContainer}>
                <BrButton onClick={() => logout()} className={styles.botao}>
                  OK
                </BrButton>
              </div>
            </div>
          </Card>
        )}

        {responseError?.message && (
          <Card className={styles.card}>
            <div className={styles.containerMensagem}>
              <img className={styles.imgMessage} src={imgErro} alt="Imagem" />
              <Message
                type={'error'}
                text={
                  <>
                    <div>
                      <span>{responseError?.message}</span>
                    </div>
                  </>
                }
              />

              <p />
              <p />
              <div className={styles.botaoContainer}>
                <BrButton onClick={() => goToHome()} className={styles.botao}>
                  OK
                </BrButton>
              </div>
            </div>
          </Card>
        )}
      </div>
    )
  }

  const painelPreCadastro = (
    <>
      {!responseError?.message &&
        !renderMessageSucesso() &&
        !renderMessageAlerta() &&
        !renderMessageErro() && (
          <>
            <Card>
              <Grid container spacing={2}>
                <ComposicaoFamiliar></ComposicaoFamiliar>
              </Grid>

              <hr />

              <div className={styles.checkboxWrapper}>
                <Checkbox
                  color="primary"
                  onChange={handleOnChangeDeclaracao}
                  checked={isCheckedDeclaracao}
                  className={styles.checkbox}
                  inputProps={{ 'aria-label': 'secondary checkbox' }}
                />
                <span className={styles.checkboxText} onClick={handleOnChangeDeclaracao}>
                  Confirmo que desejo cancelar o Cadastro Único.
                </span>
              </div>

              <div className={styles.buttonArea}>
                <BrButton
                  onClick={() => confirmaExclusaoCadastroUnico()}
                  className={styles.button}
                  disabled={!isCheckedDeclaracao}
                >
                  Confirmar
                </BrButton>
                <BrButton
                  onClick={() => goToHome()}
                  className={`${styles.button} ${styles.secondary}`}
                >
                  Cancelar
                </BrButton>
              </div>
            </Card>
            <AjudaRapida>
              Revise os integrantes da sua família com atenção.
              <p />
              Após conferir as informações, clique na declaração, se responsabilizando pela
              exclusão de pessoa(s) por motivo de falecimento.
              <p />
            </AjudaRapida>
          </>
        )}
    </>
  );

  if (loading) {
    return <LoadingGlobal />;
  }

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const isLogado = () => {
    return (govBrLogado && situacaoCadastroFamilia) || isAuthenticatedIdPositiva ? true : false;
  };

  return (
    <MainContainer
      userNav={isLogado()}
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      titleBarraAuxiliar={permiteRemoverPreFamiliaCadUnico ? 'Cancele a sua solicitação de cadastramento' : 'Cancele o seu cadastro'}
      titleBarraAuxiliarHelp={() => setExibeTextoExplicativo(true)}
      barraAuxiliar={isLogado()}
      stoppedTitle={true}
      navFixed
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navHideArrow
      navLogout={isLogado() ? logout : undefined}
    >
      <Dialog open={exibeTextoExplicativo} onClose={() => setExibeTextoExplicativo(false)}>
        <DialogContent>
          <DialogContentText>
            <div className={styles.textoDialogo}>
              Disponível para famílias com somente uma pessoa cadastrada.
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      {exclusaoIniciada && exibicaoMensagens()}
      {exclusaoIniciada && painelPreCadastro}
      {!exclusaoIniciada && <InicioExclusaoCadastral />}
    </MainContainer>
  );
};

export default PainelExclusaoCadastral;
